export class Age {
  years: number;
  months: number;
  days: number;

  constructor(years: number, months: number, days: number) {
    this.years = years;
    this.months = months;
    this.days = days;
  }

  public static isZero(age: Age): boolean {
    return age.years == 0 && age.months == 0 && age.days == 0;
  }

  public static compareTo(age: Age, otherAge: Age) {
    if (age.years === otherAge.years && age.months === otherAge.months && age.days === otherAge.days) return 0;
    return -1;
  }

  public static lessOrEqualsThan(age: Age, otherAge: Age) {
    if (age.years < otherAge.years) return true;
    if (age.years > otherAge.years) return false;
    if (age.months < otherAge.months) return true;
    return age.months <= otherAge.months && age.days <= otherAge.days;
  }

  public static greaterOrEqualsTo(age: Age, otherAge: Age) {
    if (age.years > otherAge.years) return true;
    if (age.years < otherAge.years) return false;
    if (age.months > otherAge.months) return true;
    return age.months >= otherAge.months && age.days >= otherAge.days;
  }
}
